import { Component,OnInit} from '@angular/core';  
import { QueryBuilderConfig } from 'angular2-query-builder';
import {RuleService} from '../service/rule.service';
import {TmsService} from './service/tms.service';
import { State } from '@progress/kendo-data-query';
import { QueryBuilderFilterRule } from '../model/QueryBuilderFilterRule';
import { DialogService } from '@progress/kendo-angular-dialog';
import UtilRules from '../helper/UtilRules'
import { RuleAppliedPropertyDTO  } from '../model/RuleAppliedPropertyDTO';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import Utils from '../../helpers/Util';
import { RuleAppliedDTO  } from '../model/RuleAppliedDTO';
import { FilterLineDTO  } from '../model/FilterLineDTO';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { process } from '@progress/kendo-data-query';
import { DataBindingDirective,PageChangeEvent, GridDataResult,SelectableSettings} from '@progress/kendo-angular-grid';
import { FilterResultDTO } from '../model/FilterResultDTO';
import { FilterLine } from '../model/FilterLine';
import { FilterDTO } from '../model/FilterDTO';
import { NotificationService } from '@progress/kendo-angular-notification';
import { QueryBuilderFilterRuleDTO } from '../model/QueryBuilderFilterRuleDTO';
import { OptionDTO } from '../model/OptionDTO';

@Component({
  selector: 'app-form-rule',
  styleUrls: ['../rule.scss'],
  templateUrl: 'tms.component.html'
})

export class TMSComponent implements OnInit {  
  //rules variable here
  public data: any[] = [{ kind: '', share: 0.175,color: "#a4cbf3" },
                        {kind: '', share: 0.238,color: "#84b4e4" }];
  public state: State = { skip: 0, take: 5, };
  isRuleList:boolean = true;
  isRuleForm:boolean = false;
  gridView:GridDataResult;
  query:FilterLineDTO;
  action:string;
  public opened:boolean = false;
  parentId:Number = 0;
  config: QueryBuilderConfig = {
    fields: {
              InvoiceNo: {name: 'Invoice No', type: 'string'},
              FreightBillDate: {name: 'Invoice Date', type: 'date'},
              Status: {name: 'Invoice Status',type: 'category',options: [{name: 'InWebResolution', value: "106"},{name: 'InWebReplies', value: "107"}]},
              ClientId:{name: 'Client',type: 'category',options: []},
              Division:{name: 'Client Division',type: 'category',options: []},
              ClientSubDiv:{name: 'Client Sub Division',type: 'category',options: []},
              ClientLoc:{name: 'Client Location',type: 'category',options: []},
              ClientSubLoc:{name: 'Client Sub Location',type: 'category',options: []},
              ClientCostCentre: {name: 'Client Cost Centre', type: 'string'},
              CarrierId:{name: 'Carrier SCAC',type: 'category',options: []},
              CarrierLoc:{name: 'Carrier Location',type: 'category',options: []},
              CarrierCurrency:{name: 'Carrier Currency',type: 'category',options: []},
              CarrierAcctNo: {name: 'Carrier Acc No', type: 'string'},
              CarrierCountry:{name: 'Carrier Country',type: 'category',options: []},
              ShipmentMode:{name: 'Shipment Mode',type: 'category',options: []},
              ServiceType:{name: 'Service Type',type: 'category',options: []},
              FreightTerms:{name: 'Freight Terms',type: 'category',options: []},
              DurtyNonDuty: {name: 'Duty/Non Duty',type: 'category',options: [{name: 'Duty', value: "1"},{name: 'Non Duy', value: "0"}]},
              CountryCode:{name: 'Origin Country Code',type: 'category',options: []},
              OriginCity: {name: 'Orign City', type: 'string'},
              OriginPostCode: {name: 'Orign Post Code', type: 'string'},
              OriginAddress1: {name: 'Orign Address 1', type: 'string'},
              OriginAddress2: {name: 'Orign Address 2', type: 'string'},
              GeoPortCode:{name: 'Origin Port Code',type: 'category',options: []},
              DestinationCountryCode:{name: 'Destination Country Code',type: 'category',options: []},
              DestinationCity: {name: 'Destination City', type: 'string'},
              DestinationPostCode: {name: 'Destination Post Code', type: 'string'},
              DestinationGeoPortCode:{name: 'Origin Port Code',type: 'category',options: []},
              DestinationAddress1: {name: 'Destination Address 1', type: 'string'},
              DestinationAddress2: {name: 'Destination Address 2', type: 'string'},
              Accessorial:{name: 'Accessorial',type: 'category',options: []},
              TaxableNonTaxable: {name: 'Taxable/Non Taxable',type: 'category',options: [{name: 'Taxable', value: "1"},{name: 'Non-Taxable', value: "0"}]},
              InvoiceDuty: {name: 'Invoice Duty',type: 'category',options: [{name: 'Duty', value: "1"},{name: 'Non Duy', value: "0"}]},
              ShipperName: {name: 'Shipper Name', type: 'string'},
              ConsigneeName: {name: 'Consignee Name', type: 'string'},
              ShipmentAmount: {name: 'Shipment Amount', type: 'string'},
              ClientCountry:{name: 'Client Country Code',type: 'category',options: []},
              Priority: {name: 'Priority', type: 'string'},
            }
          }

  fieldsTypeMap = [
    {field: 'InvoiceNo',type:"string"},
    {field: 'Status',type:"integer"},
    {field: 'ClientId',type:"integer"},
    {field: 'Division',type:"integer"},
    {field: 'ClientSubDiv',type:"integer"},
    {field: 'ClientLoc',type:"integer"},
    {field: 'ClientSubLoc',type:"integer"},
    {field: 'ClientCostCentre',type:"string"},
    {field: 'CarrierId',type:"integer"},
    {field: 'CarrierLoc',type:"integer"},
    {field: 'CarrierCurrency',type:"integer"},
    {field: 'CarrierAcctNo',type:"string"},
    {field: 'CarrierCountry',type:"integer"},
    {field: 'FreightBillDate',type:"date"},
    {field: 'ShipmentMode',type:"string"},
    {field: 'ServiceType',type:"integer"},
    {field: 'FreightTerms',type:"integer"},
    {field: 'DurtyNonDuty',type:"integer"},
    {field: 'CountryCode',type:"integer"},
    {field: 'OriginCity',type:"string"},
    {field: 'OriginPostCode',type:"string"},
    {field: 'OriginAddress1',type:"string"},
    {field: 'OriginAddress2',type:"string"},
    {field: 'GeoPortCode',type:"integer"},
    {field: 'DestinationCountryCode',type:"integer"},
    {field: 'DestinationCity',type:"string"},
    {field: 'DestinationPostCode',type:"integer"},
    {field: 'DestinationGeoPortCode',type:"integer"},
    {field: 'DestinationAddress1',type:"string"},
    {field: 'DestinationAddress2',type:"string"},
    {field: 'Accessorial',type:"integer"},
    {field: 'TaxableNonTaxable',type:"string"},
    {field: 'InvoiceDuty',type:"string"},
    {field: 'ShipperName',type:"string"},
    {field: 'ConsigneeName',type:"string"},
    {field: 'ShipmentAmount',type:"string"},
    {field: 'ClientCountry',type:"integer"},
    {field: 'Priority',type:"string"},
  ];

  //TMS var here
  ruleLeft:Array<RuleAppliedPropertyDTO> = [];
  ruleRight:Array<RuleAppliedDTO> = [];
  subs = new Subscription();
  public rulePageSize = 5;
  public pageNo = 0;
  public totalSize:number = 0;
  page:number = 0;
  pageSize:number = 10;
  gridRules:Array<FilterDTO>;
  listRuleSelected: boolean;
  filter:FilterDTO = { "Id":0, "Context":"Coding", "FilterName":null,"Priority":1,"ClientCode":"","TabTitle":this.clientCode,"IsChecked":false};
  
  constructor(private _dialogService: DialogService, 
              private _ruleService:RuleService, 
              private _tmsService: TmsService,
              private _dragulaService:DragulaService, 
              private notificationService: NotificationService) {  }  

  ngOnInit(): void {   
    this.refreshRuleList();
  }  


  preventDragging() {
    this._dragulaService.createGroup("VAMPIRES", {
      copy: (el, source) => {
        return source.id === 'left';
      },
      copyItem: (rule) => {
        return rule;
      },
      accepts: (el, target, source, sibling) => {
        return target.id !== 'left';
      }
    });
  }

  public onTabSelect(e) {
    if(e.title === 'Filter List'){
      this.action = "";
      this.isRuleList = true;
      this.isRuleForm = false;
      this.refreshRuleList();
    }else{
      this.addFilter();
    }
  }

  public selectRuleList(e)
  {
       let ruleList = Utils.DeepCopy(this.gridView.data)
       let checkedRule = ruleList.find(item => item.IsChecked === true);
       if (checkedRule)
       {
        ruleList = ruleList.filter(function(rList)
       {
         return rList.IsChecked === true
       });

       let listIds = [];
       ruleList.forEach(value =>
        {
          listIds.push(value.Id)
        })
        console.log(listIds);
       } 
  }

  public onMassDelete()
  {
    let ruleList = Utils.DeepCopy(this.gridView.data)
    let checkedRule = ruleList.find(item => item.IsChecked === true);
    if (checkedRule)
    {
        ruleList = ruleList.filter(function(rList)
        {
          return rList.IsChecked === true
        });
        let listIds = [];
        ruleList.forEach(value =>
        {
          listIds.push(value.Id)
        })
    
        this._tmsService.MassDeleteRulesList(listIds).subscribe((data:Array<Number>) =>
        {
          this.deleteMessage();
          this.refreshRuleList();
        });
    } 
    else
    {
      this._dialogService.open({
        title: 'System Message',
        content:"Please select list of rule!",
        actions: [
            { text: 'OK', primary: true }
        ]
      });
    }
  }



  public onClose(isYesNo){
    if(isYesNo === "yes"){
      this._ruleService.DeleteRulesWithChild(this.parentId).subscribe((data:any) => 
      {
        this.notificationService.show({
          content: 'Successfully deleted!',
          animation: { type: 'fade', 
          duration: 500 },
          type: { style: 'info', icon: true }
         });
        this.refreshRuleList();
      });
    } 
     this.opened = false;
  }
  
  public sliderChange(pageIndex: number): void {
    this.state.skip = (pageIndex - 1) * this.rulePageSize;

  }


  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.pageNo = (this.state.skip / this.state.take);
    this._tmsService.GetFilters(this.pageNo,this.rulePageSize).subscribe((data:FilterResultDTO) => 
    { 
      this.gridRules = data.FilterList;
      this.isRuleList = true;
      this.isRuleForm = false;
      this.totalSize = data.TotalFilter;

      this.gridView = {
        data: this.gridRules,
        total: this.totalSize
      };
    });
  }
 
  public onRefresh(){
    this.refreshRuleList();
  }

  public addFilter() {
    this.isRuleList = false;
    this.isRuleForm = true;
    this.action = "add";
    this.query = { id:0, field: "", value:"", entity:"", condition: 'and', type: 'TMS', rules: [], collapsed:"",isChild:"" } as FilterLineDTO;
    this._tmsService.GetUnAppliedRules().subscribe((data:Array<RuleAppliedPropertyDTO>) =>
    {
      this.ruleLeft = data;
    });
    this.ruleRight = [];
    this.clientCode();
    this.clientDivision();
    this.clientSubDivision();
    this.clientLocation();
    this.clientSubLocation();
    this.carrierCode();
    this.carrierLocation();
    this.carrierCurrency();
    this.carrierCountry();
    this.shipmentMode();
    this.serviceType();
    this.freightTerm();
    this.countryCode();
    this.portCode();
    this.accessorialName();
    this.clientCountry();
  }

  public editFilter({dataItem}) {
    this.isRuleList = false;
    this.isRuleForm = true;
    this.action = "edit";

    this._tmsService.GetFilterById(dataItem.Id).subscribe((data:FilterDTO) => 
    {
      this.filter = data;
      this._tmsService.GetFilterLineWithChild(data.Id).subscribe((data:any) => 
      {
        this.query = data;
      });
  
      this._tmsService.GetUnAppliedRules().subscribe((data:Array<RuleAppliedPropertyDTO>) =>
      {
        this.ruleLeft = data;
      });
  
      this._tmsService.GetAppliedRulesByFilterId(data.Id).subscribe((data:Array<RuleAppliedDTO>) =>
      {
        this.ruleRight = data;
      });
      // });
      this.notificationService.show({
        content: 'Please select list of rule!',
        animation: { type: 'fade', 
        duration: 500 },
        type: { style: 'info', icon: true }
      });
    });
  }

  public removeFilter({dataItem}) {
    this.action = "delete"; 
    this.opened = true;
    this.parentId = dataItem.Id;
  }

  public deleteMessage(){
    this.notificationService.show({
      content: 'Successfully deleted',
      animation: { type: 'fade', 
      duration: 500 },
      type: { style: 'info', icon: true }
     });
  }

  onfetchMore(rule) {
    console.log(rule);
    this.page = 0;
    if(rule.field == 'ClientId'){
      this.page = this.page + 1;
      this._tmsService.GetClientCodeName(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientId.options.push(...data);
      });
    }else if(rule.field == 'Division'){
      this.page = this.page + 1;
      this._tmsService.GetClientDivision(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Division.options.push(...data);
      });
    } else if(rule.field == 'ClientSubDiv'){
      this.page = this.page + 1;
      this._tmsService.GetClientSubDivision(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientSubDiv.options.push(...data);
      });
    } else if(rule.field == 'ClientLoc'){
      this.page = this.page + 1;
      this._tmsService.GetClientLocation(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientLoc.options.push(...data);
      });
    } else if(rule.field == 'ClientSubLoc'){
      this.page = this.page + 1;
      this._tmsService.GetClientSubLocation(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientSubLoc.options.push(...data);
      });
    } else if(rule.field == 'ClientCountry'){
      this.page = this.page + 1;
      this._tmsService.GetClientCountryCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientCountry.options.push(...data);
      });
    } else if(rule.field == 'CarrierId'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierCodeName(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierId.options.push(...data);
      });
    } else if(rule.field == 'CarrierLoc'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierLocation(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierLoc.options.push(...data);
      });
    } else if(rule.field == 'CarrierCurrency'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierCurrency(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierCurrency.options.push(...data);
      });
    } else if(rule.field == 'CarrierCountry'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierCountryCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierCountry.options.push(...data);
      });
    }
    if(rule.field == 'ShipmentMode'){
      this.page = this.page + 1;
      this._tmsService.GetShipMode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ShipmentMode.options.push(...data);
      });
    } else if(rule.field == 'ServiceType'){
      this.page = this.page + 1;
      this._tmsService.GetSrvceType(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ServiceType.options.push(...data);
      });
    } else if(rule.field == 'FreightTerms'){
      this.page = this.page + 1;
      this._tmsService.GetFreightTerm(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.FreightTerms.options.push(...data);
      });
    } else if(rule.field == 'CountryCode' || rule.field == 'DestinationCountryCode'){
      this.page = this.page + 1;
      this._tmsService.GetCountryCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CountryCode.options.push(...data);
        this.config.fields.DestinationCountryCode.options.push(...data);
      });
    } else if(rule.field == 'GeoPortCode' || rule.field == 'DestinationGeoPortCode'){
      this.page = this.page + 1;
      this._tmsService.GetGeoPortCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.GeoPortCode.options.push(...data);
        this.config.fields.DestinationGeoPortCode.options.push(...data);
      });
    } else if(rule.field == 'Accessorial'){
      this.page = this.page + 1;
      this._tmsService.GetAccessorialName(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Accessorial.options.push(...data);
      });
    }
  }

  onSearch($event){
    this.page = 0;
    if($event.field == 'ClientId'){
      this.page = this.page + 1;
      this._tmsService.GetClientCodeNameByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientId.options = data;
      });
    }else if($event.field == 'Division'){
      this.page = this.page + 1;
      this._tmsService.GetClientDivisionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Division.options = data;
      });
    } else if($event.field == 'ClientSubDiv'){
      this.page = this.page + 1;
      this._tmsService.GetClientSubDivisionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientSubDiv.options = data;
      });
    } else if($event.field == 'ClientLoc'){
      this.page = this.page + 1;
      this._tmsService.GetClientLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientLoc.options = data;
      });
    } else if($event.field == 'ClientSubLoc'){
      this.page = this.page + 1;
      this._tmsService.GetClientSubLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientSubLoc.options = data;
      });
    } else if($event.field == 'ClientCountry'){
      this.page = this.page + 1;
      this._tmsService.GetClientCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ClientCountry.options = data;
      });
    } else if($event.field == 'CarrierId'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierCodeNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierId.options = data;
      });
    } else if($event.field == 'CarrierLoc'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierLoc.options = data;
      });
    } else if($event.field == 'CarrierCurrency'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierCurrencyFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierCurrency.options = data;
      });
    } else if($event.field == 'CarrierCountry'){
      this.page = this.page + 1;
      this._tmsService.GetCarrierCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierCountry.options = data;
      });
    }
    if($event.field == 'ShipmentMode'){
      this.page = this.page + 1;
      this._tmsService.GetShipModeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ShipmentMode.options = data;
      });
    } else if($event.field == 'ServiceType'){
      this.page = this.page + 1;
      this._tmsService.GetSrvceTypeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.ServiceType.options = data;
      });
    } else if($event.field == 'FreightTerms'){
      this.page = this.page + 1;
      this._tmsService.GetFreightTermFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.FreightTerms.options = data;
      });
    } else if($event.field == 'CountryCode' || $event.field == 'DestinationCountryCode'){
      this.page = this.page + 1;
      this._tmsService.GetCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CountryCode.options = data;
        this.config.fields.DestinationCountryCode.options = data;;
      });
    } else if($event.field == 'GeoPortCode' || $event.field == 'DestinationGeoPortCode'){
      this.page = this.page + 1;
      this._tmsService.GetGeoPortCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.GeoPortCode.options = data;
        this.config.fields.DestinationGeoPortCode.options = data;
      });
    } else if($event.field == 'Accessorial'){
      this.page = this.page + 1;
      this._tmsService.GetAccessorialNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Accessorial.options = data;
      });
    }
  }

  resetPage(){
    this.page = 0;
  }
  public clientCode()
  {
    console.log(this.page);
    this._tmsService.GetClientCodeName(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ClientId.options = data;
    });
  }


  public clientDivision()
  {
    this._tmsService.GetClientDivision(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.Division.options = data;
    });
  }

  public clientSubDivision()
  {
    this._tmsService.GetClientSubDivision(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ClientSubDiv.options = data;
    });
  }

  public clientLocation()
  {
    this._tmsService.GetClientLocation(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ClientLoc.options = data;
    });
  }
  public clientSubLocation()
  {
    this._tmsService.GetClientSubLocation(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ClientSubLoc.options = data;
    });
  }
  public clientCountry()
  {
    this._tmsService.GetClientCountryCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ClientCountry.options = data;
    });
  }

  public carrierCode()
  {
    this._tmsService.GetCarrierCodeName(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.CarrierId.options = data;
    });
  }

  public carrierLocation()
  {
    this._tmsService.GetCarrierLocation(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.CarrierLoc.options = data;
    });
  }

  public carrierCurrency()
  {
    this._tmsService.GetCarrierCurrency(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.CarrierCurrency.options = data;
    });
  }

  public carrierCountry()
  {
    this._tmsService.GetCarrierCountryCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.CarrierCountry.options = data;
    });
  }
  public shipmentMode()
  {
    this._tmsService.GetShipMode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ShipmentMode.options = data;
    });
  }
  public serviceType()
  {
    this._tmsService.GetSrvceType(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ServiceType.options = data;
    });
  }
  public freightTerm()
  {
    this._tmsService.GetFreightTerm(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.FreightTerms.options = data;
    });
  }
  public countryCode()
  {
    this._tmsService.GetCountryCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.CountryCode.options = data;
      this.config.fields.DestinationCountryCode.options = data;
    });
  }
  public portCode()
  {
    this._tmsService.GetGeoPortCode(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.GeoPortCode.options = data;
      this.config.fields.DestinationGeoPortCode.options = data;
    });
  }
  public accessorialName()
  {
    this._tmsService.GetAccessorialName(this.page,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.Accessorial.options = data;
    });
  }

  
  public refreshRuleList()
  {
    this._tmsService.GetFilters(this.state.skip,this.rulePageSize).subscribe((data:FilterResultDTO) => 
    { 
      this.gridRules = data.FilterList;
      this.isRuleList = true;
      this.isRuleForm = false;
      this.totalSize = data.TotalFilter;
      this.gridView = {
        data: this.gridRules,
        total: this.totalSize
      };
    });
  }
  public allData(): ExcelExportData {
    const result: ExcelExportData =  {
        data: process(this.gridRules, { sort: [{ field: 'Id', dir: 'asc' }] }).data
    };

    return result;
  }


  public sucessMessage(){
    this.notificationService.show({
      content: 'Successfully save!',
      animation: { type: 'fade', 
      duration: 500 },
      type: { style: 'info', icon: true }
     });
  }

  public sucessUpdateMessage(){
    this.notificationService.show({
      content: 'Successfully updated!',
      animation: { type: 'fade', 
      duration: 500 },
      type: { style: 'info', icon: true }
     });
  }

  public saveFilter(query){
    // var tempData = Utils.DeepCopy(query);
    // UtilRules.FormatRule(tempData,this.fieldsTypeMap);
    // var data = <QueryBuilderFilterRule> tempData;
    
    // if(this.action === "add"){
    //   this._tmsService.SaveFilter(this.filter).subscribe((filterId:number) => 
    //   {
    //     let temp:QueryBuilderFilterRuleDTO = { "FilterId": filterId, "QueryBuilderFilterRule": data }
    //     this._tmsService.SaveFilterLine(temp).subscribe((filterLineId:any) => 
    //     {
    //         this._tmsService.GetFilterLineWithChild(filterId).subscribe((data:any) => 
    //         {
    //           this.query = data;
    //           this.action = "edit";
    //           this.sucessMessage();
    //         });
    //     });
    //   })
    // }else if(this.action == "edit"){
    //   this._tmsService.UpdateFilter(this.filter).subscribe((filterId:any) => 
    //   {
    //     let temp:QueryBuilderFilterRuleDTO = { "FilterId": this.filter.Id, "QueryBuilderFilterRule": data }
    //     this._tmsService.UpdateFilterLine(data).subscribe((filterLineId:any) => 
    //     {
    //       this._tmsService.GetFilterLineWithChild(this.filter.Id).subscribe((data:any) => 
    //       {
    //         this.query = data;
    //         this.action = "edit";
    //         this.sucessMessage();
    //       });
    //     });
    //   });
    // }
  }

  //this will triger after save in applied rule press
  public onSaveAppliedRule(ruleApplied:Array<RuleAppliedDTO>){
    // if(this.query.id == 0){
    //   var tempData = Utils.DeepCopy(this.query);
    //   UtilRules.FormatRule(tempData,this.fieldsTypeMap);
    //   var filterData = <QueryBuilderFilterRule> tempData;
    //   this._tmsService.SaveFilter(this.filter).subscribe((filterId:number) => 
    //   {
    //     let temp:QueryBuilderFilterRuleDTO = { "FilterId": filterId, "QueryBuilderFilterRule": filterData }
    //     this._tmsService.SaveFilterLine(temp).subscribe((filterLineId:any) => 
    //     {
    //        ruleApplied.forEach(item => item.FilterId = filterId);
    //        ruleApplied = ruleApplied.filter(function(item) {
    //          return item.IsApplied === false;
    //        });
    //        this._tmsService.SaveAppliedRules(ruleApplied).subscribe((data:Array<RuleAppliedDTO>) =>
    //        {
    //           this._tmsService.GetFilterLineWithChild(filterId).subscribe((data:any) => 
    //           {
    //               this.query = data;
    //               this.action = "edit";
    //               this.sucessMessage();
    //           });
    //           this._tmsService.GetAppliedRulesByFilterId(filterId).subscribe((data:Array<RuleAppliedDTO>) =>
    //           {
    //             this.ruleRight = data;
    //           });
    //        });
    //     });
    //   });
    // }else{
    //   ruleApplied.forEach(item => item.FilterId = this.filter.Id);
    //   ruleApplied = ruleApplied.filter(function(item) {
    //     return item.IsApplied === true;
    //   });
  
    //   this._tmsService.SaveAppliedRules(ruleApplied).subscribe((data:Array<RuleAppliedDTO>) =>
    //   {
    //     this._tmsService.GetAppliedRulesByFilterId(this.filter.Id).subscribe((data:Array<RuleAppliedDTO>) =>
    //     {
    //       this.ruleRight = data;
    //       this.sucessUpdateMessage();
    //     });
    //   });
    // }
  }

  public onSaveProperties(ruleApplied){
    // if(ruleApplied.RuleProperty.length === 0){
    //   return;
    // }
    // if(this.query.id == 0){
    //   var tempData = Utils.DeepCopy(this.query);
    //   UtilRules.FormatRule(tempData,this.fieldsTypeMap);
    //   var filterData = <QueryBuilderFilterRule> tempData;
    //   this._tmsService.SaveFilter(this.filter).subscribe((filterId:number) => 
    //   {
    //     let temp:QueryBuilderFilterRuleDTO = { "FilterId": filterId, "QueryBuilderFilterRule": filterData }
        
    //     this._tmsService.SaveFilterLine(temp).subscribe((filterLineId:any) => 
    //     { 
    //       ruleApplied.FilterId = filterId;
    //       this._tmsService.SaveAppliedProperties(ruleApplied).subscribe((data:Array<RuleAppliedPropertyDTO>) =>
    //       {
    //           this._tmsService.GetFilterLineWithChild(filterId).subscribe((data:any) => 
    //           {
    //           this.query = data;
    //           this.action = "edit";
    //           this.sucessMessage();
    //           });
    //           this._tmsService.GetAppliedRulesByFilterId(filterId).subscribe((data:Array<RuleAppliedDTO>) =>
    //           {
    //             this.ruleRight = data;
    //           });
    //       });
    //     });
    //   });
    // }else{
    //   ruleApplied.FilterId = this.filter.Id; 
    //   this._tmsService.SaveAppliedProperties(ruleApplied).subscribe((data:Array<RuleAppliedPropertyDTO>) =>
    //   {
    //     this.sucessUpdateMessage();
    //   });
    // }

  }
}


